import { FormGroup } from '@angular/forms';

/** The values of the top-level fields the person has changed, to put back after the form is refilled. */
export function editedValues(form: FormGroup): Record<string, any> {
  const edits: Record<string, any> = {};
  Object.entries(form.controls).forEach(([name, control]) => {
    if (control.dirty) edits[name] = control.value;
  });
  return edits;
}

/** Puts changed fields back over a refill, still marked as changed so a later refill keeps them too. */
export function restoreEdits(form: FormGroup, edits: Record<string, any>): void {
  Object.entries(edits).forEach(([name, value]) => {
    const control = form.get(name);
    if (!control) return;
    control.setValue(value);
    control.markAsDirty();
  });
}
